export const SDK_VERSION = '8.15.0';
